import React, { useState, useEffect } from "react";
import { Card, CardBody, Col, Button, Spinner } from "reactstrap";
import DataTable, { TableColumn } from "react-data-table-component";
import { CustomerTitle, PackageBoughtTitle } from "../../../Utils/Constants";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
import axios from "axios";
import useCurrency, { baseUrl } from "../../../Utils/FileUpload";
import FilterComponent from "../../../Components/Tables/DataTables/Common/FilterComponent";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
interface PackageBought {
  id: number;
  type: "video" | "audio"; // new field
  customer: {
    id: number;
    mobile: number;
  };
  package: {
    id: string | null;
    name: string | null;
    amount: string | null;
  };
  amount: string;
  date: string;
}
export default function PackageBought() {
  const [filterText, setFilterText] = useState("");
  const [filteredItems, setFilteredItems] = useState<PackageBought[]>([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  const location = useLocation();
  const { currency } = useCurrency();
  const customerId = location?.state?.id || null;
  // console.log(customerId)
  let personTitle = "";

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${baseUrl}customer_detail/get_packages_bought`,
          { customer_id: customerId }, // POST body
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        let data: PackageBought[] = response.data.data || []; // access 'data' field from Laravel response

        setFilteredItems(data);
      } catch (error) {
        console.error("Error fetching package bought data:", error);
        // toast.error("Failed to fetch packages bought.");
      } finally {
        setLoading(false);
      }
    };

    if (customerId) {
      fetchData();
    }
  }, [customerId]);

  const filteredData = filteredItems.filter((item) => {
    return (
      (item.package.name &&
        item.package.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.amount &&
        item.amount.toString().includes(filterText.toLowerCase())) ||
      (item.package.amount &&
        item.package.amount.toString().includes(filterText.toLowerCase())) ||
      (item.date &&
        item.date.toLowerCase().includes(filterText.toLowerCase()))
    );
  });

  // Define columns with actions dynamically based on customerId and customerId
  const getPackageBoughtColumns = (): TableColumn<PackageBought>[] => {
    const columns: TableColumn<PackageBought>[] = [];

    columns.push(
      {
        name: "Package Name",
        selector: (row: PackageBought) => row.package?.name ?? "",
        sortable: true,
      },
      {
        name: `Package Amount ${currency ? `(${currency})` : ""}`,
        selector: (row: PackageBought) =>
          row?.amount ?? row?.package?.amount ?? "",
        sortable: true,
      },
      {
        name: "Type",
        selector: (row: PackageBought) => row.type ?? "",
        sortable: true,
      },
      {
        name: "Date",
        selector: (row: PackageBought) => row.date ?? "",
        sortable: true,
      }
    );

    return columns;
  };

  // Show a loading spinner while data is being fetched
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spinner color="primary" />
      </div>
    );
  }

  const customStyles = {
    headCells: {
      style: {
        fontSize: "16px",
        fontWeight: "600",
        color: "#308e87",
        backgroundColor: "#f8f9fa",
        borderBottom: "2px solid #308e87",
      },
    },
    rows: {
      style: {
        borderBottom: "1px solid #dee2e6",
      },
    },
    table: {
      style: {
        border: "1px solid #dee2e6",
        borderRadius: "8px",
      },
    },
  };

  return (
    <>
      <Breadcrumbs
        pageTitle={PackageBoughtTitle}
        parent={CustomerTitle}
        title={PackageBoughtTitle}
      />
      <Col xl={12} className="mb-lg-3">
        <Card>
          <CardBody>
            {personTitle && (
              <h5
                style={{
                  marginBottom: "1rem",
                  color: "#308e87",
                  fontWeight: "600",
                }}
              >
                {personTitle}
              </h5>
            )}

            <div className="mb-3">
              <FilterComponent
                onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setFilterText(e.target.value)
                }
                filterText={filterText}
              />
            </div>
            <div className="table-responsive custom-scrollbar">
              <DataTable
                data={filteredData}
                // columns={packageBoughtTableColumns}
                columns={getPackageBoughtColumns()}
                pagination
                highlightOnHover
                striped
                customStyles={customStyles}
              />
            </div>
          </CardBody>
        </Card>
      </Col>
      <ToastContainer />
    </>
  );
}
